import Home from '../views/Home/index.vue';
import OpenList from '../views/Open/open-list.vue';
import OpenPay from '../views/Open/open-pay.vue';
import OpenModule from '../views/Open/open-module.vue';
import OpenConfirm from '../views/Open/open-confirm.vue';
import Charge from '../views/Charge/index.vue';
import ChargeRecord from '../views/Charge/charge-record.vue';
import ChargeApply from '../views/Charge/charge-apply.vue';
import BillList from '../views/Bill/bill-list.vue';
import BillDetail from '../views/Bill/bill-detail.vue';
import MessageList from '../views/Bill/message-list.vue';
import Renew from '../views/Renew/renew.vue';
import Urgent from '../views/Bill/urgent-list.vue';
import Netin from '../views/Netin/netin.vue';
import ChooseStore from '../views/Netin/choose-store.vue';
import Operate from '../views/Home/operate.vue';
import ChooseOrder from '../views/Home/choose-order.vue';
import Loading from '../views/Home/loading.vue';

export default [
  { path: '/', redirect: '/home' },
  { path: '/home', name: 'home', component: Home},
  { path: '/operate/:id', name: 'operate', component: Operate },
  // 开通
  { path: '/open-list', name: 'open-list', component: OpenList },
  { path: '/open-module', name: 'open-module', component: OpenModule },
  { path: '/open-confirm', name: 'open-confirm', component: OpenConfirm },
  // 充值
  { path: '/charge', name: 'charge', component: Charge },
  { path: '/charge-record', name: 'charge-record', component: ChargeRecord },
  { path: '/charge-apply', name: 'charge-apply', component: ChargeApply },
  { path: '/charge-pay', name: 'charge-pay', component: OpenPay },
  // 账单
  { path: '/bill-list', name: 'bill-list', component: BillList },
  { path: '/bill-detail/:id', name: 'bill-detail', component: BillDetail },
  // 消息
  { path: '/message-list', name: 'message-list', component: MessageList },
  // 续费
  { path: '/renew', name: 'renew', component: Renew },
  // 急需续费
  { path: '/urgent', name: 'urgent', component: Urgent },
  // 变更
  { path: '/netin', name: 'netin', component: Netin },
  { path: '/choose-store/:id', name: 'choose-store', component: ChooseStore },
  { path: '/choose-order/:id', name: 'choose-order', component: ChooseOrder },
]
